import {lighten} from 'polished';
import DatePickerComponent from 'react-datepicker';
import styled, {css} from 'styled-components';

import {colors} from '../../../theme';

export const InnerDatePicker = styled(DatePickerComponent)``;

export const DatePickerHead = styled.div`
    margin: 10px;
    display: grid;
    grid-template-columns: auto 1fr 80px auto;
    align-items: center;
    gap: 5px;
`;

export const DatePickerArrow = styled.button<{disabled?: boolean; right?: boolean}>`
    display: flex;
    gap: 5px;
    justify-content: center;
    align-items: center;
    border: 2px solid ${colors.brandPrimary};
    border-radius: 50%;
    width: 25px;
    height: 25px;
    background: ${colors.transparent};
    color: ${colors.brandPrimary};
    cursor: pointer;
    transition: all 0.15s ease-in-out;

    & > * {
        position: relative;
        top: 1px;
        right: 1px;
    }

    ${(p) =>
        p.disabled &&
        css`
            pointer-events: none;
            color: ${colors.textMuted};
            border-color: ${colors.textMuted};
        `}

    ${(p) =>
        p.right &&
        css`
            & > * {
                transform: rotate(180deg);
                right: 0;
            }
        `}
`;

export const globalStyles = css`
    .react-datepicker-wrapper {
        display: block !important;
    }

    .react-datepicker__input-container {
        display: block !important;
    }

    .react-datepicker {
        border: none;
        font-size: 14px;

        &__current-month {
            font-weight: 500;
            text-transform: capitalize;
        }

        &__day--outside-month {
            color: ${colors.textSecondary};
        }

        &__day-name {
            color: ${colors.textSecondary};
            text-transform: capitalize;
            padding: 0.3rem;
        }

        &__day-names {
            padding-top: 5px;
        }

        &__day--selected {
            background-color: ${colors.brandPrimary};
        }

        &__day--keyboard-selected {
            background-color: ${colors.brandPrimary};
        }

        &__day--in-range {
            background-color: ${colors.brandPrimary};
        }

        &__day {
            border-radius: 100%;
            padding: 0.3rem;

            &:hover,
            &--selected,
            &--selected:hover,
            &--in-range,
            &--in-range:hover,
            &--in-selecting-range,
            &--in-selecting-range:hover {
                border-radius: 100%;
                transition: all 0.15s ease-in-out;
            }
        }

        &__day--in-selecting-range,
        &__month-text--in-selecting-range,
        &__quarter-text--in-selecting-range {
            background-color: ${lighten(0.1, colors.brandPrimary)};
            color: ${colors.white};

            &:hover {
                background-color: ${colors.brandPrimary};
            }

            &.react-datepicker {
                font-size: 12px;
                font-family: inherit;
                border: 0;
                padding: 10px;
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07), 0 2px 4px rgba(0, 0, 0, 0.07),
                    0 4px 8px rgba(0, 0, 0, 0.07), 0 8px 16px rgba(0, 0, 0, 0.07),
                    0 16px 32px rgba(0, 0, 0, 0.07), 0 32px 64px rgba(0, 0, 0, 0.07);
            }
        }

        &__header {
            background-color: ${colors.white};
            border-bottom: 1px solid ${colors.border};
        }

        &__navigation {
            top: 22px;
        }

        &__navigation--previous {
            top: 12px;
            left: 30px;
            border: 0;
            border-left: 2px solid ${colors.textPrimary};
            border-bottom: 2px solid ${colors.textPrimary};
            transform: rotate(45deg);
            outline: none;
        }

        &__navigation--next {
            top: 12px;
            right: 30px;
            border: 0;
            border-left: 2px solid ${colors.textPrimary};
            border-bottom: 2px solid ${colors.textPrimary};
            transform: rotate(-135deg);
            outline: none;
        }

        &__month-container {
            box-shadow: 0 0 8px #84848433;
            border-radius: 16px;
            padding: 10px;
        }
    }
`;
